'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (app) {
  app.factory('pickerView', function ($rootScope, $timeout, $ionicScrollDelegate, baseModal) {

    /**
     * default props
     */
    var props = {
      /**
       * header 标题
       */
      title: {
        type: String,
        default: '选择'
      },
      /**
       * 内容覆盖整个视窗 默认为false
       */
      fullScreen: {
        type: Boolean,
        default: false
      },
      /**
       * modal视图样式 配合fullScreen使用 默认为空 即不做设置
       */
      modalViewStyle: {
        type: Object,
        default: {
          height: '324px'
        }
      },
      /**
       *  背景颜色灰色透明 默认为false 当fullScreen为false时 值为true
       */
      backdropTransparentGray: {
        type: Boolean,
        default: false
      },
      /**
       * 取消操作的按钮名称 默认为'返回'
       */
      cancelButtonName: {
        type: String,
        default: '返回'
      },
      /**
       * 重置操作的按钮名称 默认为'重置'
       */
      resetButtonName: {
        type: String,
        default: '重置'
      },
      /**
       * 层级 显示几列
       */
      columnCount: {
        type: Number,
        default: 1
      },
      /**
       * 数据源 预先定义好的一个 嵌套结构的数组
       */
      datasource: {
        type: Array,
        default: []
      },
      /**
       * 数据源 如果是异步获取 接收一个promise对象
       */
      loadDatasource: {
        type: Function,
        default: null
      },
      /**
       * 事件 选项改变后触发
       */
      onChange: {
        type: Function,
        default: null
      },
      /**
       * 事件 点击重置后触发
       */
      onReset: {
        type: Function,
        default: null
      }
    };

    /**
     * 获取选中的值
     */
    function getSelectionResults(scope) {
      var array = [];
      for (var i = 0, l = scope.columns.length; i < l; i++) {
        var item = scope.columns[i].selectionResult;
        array.push(item ? {
          value: item.value,
          text: item.text
        } : null);
      }
      return array;
    }

    /**
     * 加载数据
     */
    function loadDatasource(scope, options) {
      scope.columns[0].loading = true;
      scope.ui.errorMessage = '';
      if ((0, _objectType.isFunction)(options.loadDatasource)) {
        $timeout(function () {
          options.loadDatasource({
            done: function done(data) {
              scope.loaded = true;
              scope.ui.errorMessage = '';
              scope.columns[0].items = data;
              scope.columns[0].loading = false;
            },
            failed: function failed(errorMessage) {
              scope.loaded = false;
              scope.ui.errorMessage = errorMessage || '加载失败';
              scope.columns[0].loading = false;
            }
          });
        }, 500);
      } else {
        scope.loaded = true;
        scope.columns[0].items = options.datasource;
        $timeout(function () {
          scope.columns[0].loading = false;
        }, 100);
      }
    }

    /**
     * 创建 options
     */
    function createOptions(options) {
      var _this = this,
          _options = {};

      (0, _forEach2.default)(props, function (value, key) {
        _options[key] = value.default;
      });

      // options setter
      _this.updateOptions = function (options) {
        if ((0, _objectType.isObject)(options)) {
          (0, _forEach2.default)(options, function (value, key) {
            if (props.hasOwnProperty(key)) {
              if (!(0, _objectType.isNullOrUndefined)(value)) {
                if (value.constructor === props[key].type) {
                  _options[key] = value;
                } else {
                  throw 'Invalid prop: type check failed for prop "' + key + '". Expected ' + props[key].type.name + ', got ' + value.constructor.name + '.';
                }
              }
            }
          });
        }
        return _options;
      };

      return _this.updateOptions(options);
    }

    /**
     * 创建 scope
     */
    function createScope(scope, options) {
      var _this = this;
      scope = scope && scope.$new() || $rootScope.$new(true);

      // 设置一个变量 判断是否数据是否加载完成
      scope.loaded = false;

      // 定义每列的实例
      scope.columns = [];
      scope.currentIndex = 0;
      scope.prepareIndex = 0;
      var rowUiHeight = 36;

      scope.ui = {
        title: options.title,
        cancelButtonName: options.cancelButtonName,
        resetButtonName: options.resetButtonName,
        slideStyle: '',
        errorMessage: ''
      };

      scope.$watch('currentIndex', function (_newValue, oldValue) {
        var newValue = _newValue;
        if (newValue !== oldValue) {
          scope.ui.slideStyle = {
            transform: 'translate3d(-' + newValue * 100 + '%,0,0)',
            '-webkit-transform': 'translate3d(-' + newValue * 100 + '%,0,0)'
          };
          var columnCurrent = scope.columns[newValue];
          if (columnCurrent.selectionResult) {
            // scroll滚动到选中项的位置
            $ionicScrollDelegate.$getByHandle(columnCurrent.handle).scrollTo(0, columnCurrent.selectionPosition - 2 * rowUiHeight);
          } else {
            // scroll滚动到顶部
            $ionicScrollDelegate.$getByHandle(columnCurrent.handle).scrollTop();
          }
        }
      });

      scope.tabItemClick = function (index) {
        scope.currentIndex = index;
      };

      for (var i = 0; i < options.columnCount; i++) {
        scope.columns[i] = {
          loading: true,
          number: i,
          tabVisible: false,
          items: [],
          selectionResult: null,
          selectionPosition: 0,
          handle: 'pickerViewScrollHandle' + i,
          itemClick: function itemClick(item, index) {
            var _this2 = this;

            this.selectionResult = item;
            this.selectionPosition = rowUiHeight * index;
            if (this.number < options.columnCount - 1) {
              scope.currentIndex = this.number + 1;
              scope.prepareIndex = this.number + 1;

              var _loop = function _loop(_i) {
                var nextColumn = scope.columns[_i + 1];
                nextColumn.selectionResult = null;
                if (_i === _this2.number) {
                  nextColumn.loading = true;
                  nextColumn.items = _this2.selectionResult.sub;
                  $timeout(function () {
                    nextColumn.loading = false;
                  });
                }
              };

              for (var _i = this.number; _i < options.columnCount - 1; _i++) {
                _loop(_i);
              }
            } else {
              // 已完成全部选择
              if ((0, _objectType.isFunction)(options.onChange)) {
                options.onChange.apply(null, getSelectionResults(scope));
              }
              _this.hide();
            }
          }
        };
      }

      // 重新加载
      scope.reload = function () {
        if (!scope.columns[0].loading) {
          loadDatasource(scope, options);
        }
      };

      // 返回
      scope.back = function () {
        _this.hide();
      };

      // 确定
      scope.affirm = function () {
        if ((0, _objectType.isFunction)(options.onChange)) {
          options.onChange.apply(null, getSelectionResults(scope));
        }
        _this.hide();
      };

      // 重置
      scope.reset = function () {
        scope.currentIndex = 0;
        scope.prepareIndex = 0;
        for (var _i2 = 0; _i2 < options.columnCount; _i2++) {
          scope.columns[_i2].selectionResult = null;
          scope.columns[_i2].selectionPosition = 0;
        }
        if ((0, _objectType.isFunction)(options.onReset)) {
          options.onReset.apply(null, getSelectionResults(scope));
        }
      };

      // 销毁实例
      scope.$on('$destroy', function () {
        _this.remove();
        _this = null;
        scope = null;
      });

      return scope;
    }

    /**
     * 创建baseModal实例
     */
    function createModal(scope, options) {
      return baseModal.fromTemplate(scope, {
        slideDirection: 'up',
        fullScreen: options.fullScreen,
        modalViewStyle: options.modalViewStyle,
        modalViewClassName: 'picker-view'
      }, require('./pickerview.html'));
    }

    function PickerView(scope, options) {

      var self = this;

      var _options = createOptions.call(self, options);

      var _scope = createScope.call(self, scope, _options);

      var _modal = createModal(_scope, _options);

      /**
       * 提供外部一个接口 手动加载数据 该加载动作会在下一次显示modal的时候 执行
       */
      self.reload = function () {
        _scope.loaded = false;
      };

      /**
       * 显示 modal
       */
      self.show = function (options) {
        if (options) {
          if (options) {
            this.updateOptions({
              title: options.title,
              onChange: options.onChange,
              onReset: options.onReset
            });
          }
        }
        return _modal.show().then(function () {
          _scope.$evalAsync(function () {
            if (!_scope.loaded) {
              // 加载一次数据
              loadDatasource(_scope, _options);
            }
          });
        });
      };

      /**
       * 重置选项
       */
      self.reset = function () {
        _scope.reset();
      };

      /**
       * 隐藏 modal
       */
      self.hide = function () {
        return _modal.hide();
      };

      /**
       * 从dom中删除 modal
       */
      self.remove = function () {
        return _modal.remove();
      };

      return self;
    }

    return function (scope, options) {
      return new PickerView(scope, options);
    };
  });
  return app;
};

require('angular');

require('ionic');

require('./pickerview.scss');

var _forEach = require('../../../utils/forEach');

var _forEach2 = _interopRequireDefault(_forEach);

var _objectType = require('../../../utils/objectType');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 模拟原生pickerView控件
 *
 */

;


//////////////////
// WEBPACK FOOTER
// ./src/lib/ionic1.x-common/services/pickerview/index.js
// module id = 163
// module chunks = 0